import { Injectable } from '@angular/core';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { GridPostParams } from 'common/models/utility-models/list-utility.model';
import { GridDataService } from '../../base-data-services/grid-data.service';
import { CreditReportsModel } from 'common/models/page-models/reports/credit-report/credit-report-data-model';
import { CreditReportsListingModel } from 'common/models/page-models/reports/credit-report/credit-report-grid-model';
import { CreditReportsGridPostParams } from 'common/models/page-models/reports/credit-report/credit-report-grid-params';
import { CreditChartsModel } from 'common/models/page-models/reports/credit-report/credit-reports-charts.model';


@Injectable({
  providedIn: 'root'
})
export class CreditReportsDataService extends GridDataService<CreditReportsListingModel, CreditReportsModel> {
  constructor(http: SmApiService, protected override ss: SystemService) {
    super(API_URL.fetchReportData, http, ss);
  }

  createInstance(): CreditReportsListingModel {
    return new CreditReportsListingModel();
  }

  getDeleteUrl() {
    return '';
  }

  override getGridParams(param): GridPostParams {
    return new CreditReportsGridPostParams();
  }

  override transformDataModel(data: any[], param: any) {
    super.transformDataModel(data, param);
    if (data.hasOwnProperty(param)) {
      data[param].forEach(element => {
        element.isKT = element.overallKtStatus === 0 ? 'No' : 'Yes';
        element.creditTotal = element.creditTotal === null ? 0:element.creditTotal;
      });
    }else{
      // console.log('No records found for given combination');
      this.ss.showError('No records found for given combination')
    }
    return data;
  }

  override modifyGridPostParams(queryParams) {
    let payload = this.getGridParams(queryParams);
    if (queryParams.transferData !== null) {
      payload['batch_search'] = queryParams.transferData.selectedBatch === null ? '' : queryParams.transferData.selectedBatch;
      payload['region_search'] = queryParams.transferData.selectedRegion === null ? '' : queryParams.transferData.selectedRegion;
      payload['branch_search'] = queryParams.transferData.selectedBranch === null ? '' : queryParams.transferData.selectedBranch;
      payload['state_search'] = queryParams.transferData.selectedState === null ? '' : queryParams.transferData.selectedState;
      payload['gender_search'] = queryParams.transferData.selectedGender === null ? '' : queryParams.transferData.selectedGender;
      payload['status_search'] = queryParams.transferData.selectedStatus === null ? '' : queryParams.transferData.selectedStatus;
      payload['internship_company_search'] = queryParams.transferData.selectedCompany === null ? '' : queryParams.transferData.selectedCompany;
      payload['considerYear_search'] = queryParams.transferData.selectedYear === null ? '' : queryParams.transferData.selectedYear;

    }
    return payload;
  }

  override prepareChartsData(apiData) {
    const chartsModel = new CreditChartsModel();
    let firstYear = 0;
    let secondYear = 0;
    let thirdYear = 0;
    let fourthYear = 0;
    const firstYearEligibleStudents = apiData.filter((key) => key.first_year_credit !== '0.00').length;

    apiData.forEach((key) => {
      firstYear += parseInt(key.first_year_credit);
      secondYear += parseInt(key.second_year_credit);
      thirdYear += parseInt(key.third_year_credit);
      fourthYear +=  parseInt(key.fourth_year_credit);
    });
    let studentChartData = [
      {
        name: "Year 1",
        y: (firstYear / apiData.length) *10,
        drilldown: "Year 1",
        color: "#86C8BC",
      },
      {
        name: "Year 2",
        y: (secondYear / apiData.length) * 10,
        drilldown: "Year 2",
        color: "#CEEDC7",
      },
      {
        name: "Year 3",
        y: (thirdYear / apiData.length) * 10,
        drilldown: "Year 3",
        color: "#FFF6BD",
      },
      {
        name: "Year 4",
        y: (fourthYear / apiData.length) * 10,
        drilldown: "Year 4",
        color: "#FFD4B2",
      },
    ];


    chartsModel.studentScoreChart.options = {
      chart: {
        type: "column",
        height: 300,
        width: 500,
      },
      title: {
        align: "left",
        text: "Student Credit Score Analysis (Year Wise)",
      },
      subtitle: {
        text: "Total Students: "+apiData.length, // Add your subtitle text here
        align: "center", // Optional: aligns subtitle to the left; default is center
        style: {
          fontSize: '11px', // Optional: style for subtitle font size
          fontWeight: 'bold' // Optional: style for subtitle font weight
        }
      },
      accessibility: {
        announceNewData: {
          enabled: true,
        },
      },
      xAxis: {
        type: "category",
        title: {
          text: 'Year',
        },
      },
      yAxis: {
        title: {
          text: "Credited Student Count",
        },
      },
      legend: {
        enabled: false,
      },
      plotOptions: {
        series: {
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            format: "{point.y:.0f}",
          },
        },
      },

      tooltip: {
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormat:
          '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.0f}</b><br/>',
      },

      series: [
        {
          name: "Score",
          colorByPoint: true,
          data: studentChartData,
        },
      ],
    };

    // chartsModel.studentScoreChart.data = {
    //     continue: continued,
    //     continueColor: '#0e6052',
    //     disContinue: discontinued,
    //     disContinueColor: '#01a185',
    //     complete: completed,
    //     completeColor: '#17d5b3',
    //     incomplete: incompleted,
    //     incompletedColor: '#61e1ca',
    //     notJoined: notJoined,
    //     notJoinedColor: '#9cffed'
    // }
    return chartsModel;
  }
}
